import { createSelector } from '@reduxjs/toolkit'

import type { RootState } from '@/redux/store'

export const selectSectionSettingData = createSelector(
  (state: RootState) => state['@customisation'],
  (customisation) => customisation.data.sectionSettingData,
)

export const selectCustomisation = createSelector(
  (state: RootState) => state['@customisation'],
  (customisation) => customisation.data,
)

export const selectIsPreviewMode = createSelector(
  (state: RootState) => state['@customisation'],
  (customisation) => customisation.data.previewMode,
)

export const selectSiteSettingData = createSelector(
  (state: RootState) => state['@customisation'],
  (customisation) => customisation.data.siteSettingData,
)

export const selectPreviewMode = (state: RootState): boolean =>
  state['@customisation'].data.previewMode

export const selectCurrentAction = (state: RootState) =>
  state['@customisation'].data.currentAction

export const selectThemeSettingData = (state: RootState) =>
  state['@customisation'].data.themeSettingData

export const selectSections = (
  state: RootState,
): Record<string, Customisation.Section> =>
  state['@customisation'].data.sectionSettingData.sections

export const selectImageDimensions = (
  state: RootState,
): Record<string, { width: number; height: number }> =>
  state['@customisation'].data.imageDimensions
